import React from 'react';
import ReactDOM from 'react-dom';
import { initializeApp } from 'firebase/app';
import Root from 'components/Root/Root';
import portalsInit from 'utils/portals';
import portalsSelectors from 'constants/portals';
import { firebaseConfig } from 'constants/firebase';
import { firebaseRegistration } from 'utils/firebase';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

portalsInit(portalsSelectors);

initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);

// Service worker
serviceWorkerRegistration.register({
  onSuccess: firebaseRegistration,
  onUpdate: firebaseRegistration,
});
